import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { showError, showSuccess } from "../components/Utils/toastUtils";
import { ArmRoll } from "../components/Utils/DescripcionesPlatos";
import { Plus, Minus, Info } from "lucide-react";
import { FaChevronDown, FaChevronUp, } from "react-icons/fa";
import Japan from "../img/Japan.webp"

import { nanoid } from "nanoid";
import { AnimatePresence, motion } from "framer-motion";
import { PageModal } from "../components/Utils/CustomStyles";

const RollPerson = () => {
  const navigate = useNavigate();

  // 📦 Generador de un nuevo roll
  const nuevoRoll = () => ({
    id: nanoid(),
    base: null,
    proteinas: [],
    rellenos: [],
    toppings: [],
  });

  const [rollActual, setRollActual] = useState(nuevoRoll());
  const [mostrarBanner, setMostrarBanner] = useState(false);
  const [mostrarModalAgregarMas, setMostrarModalAgregarMas] = useState(false);
  const [deseaNombrar, setDeseaNombrar] = useState("");
  const [nombreRoll, setNombreRoll] = useState("");
  const [mostrarBoton, setMostrarBoton] = useState(true);
const [lastScrollY, setLastScrollY] = useState(0);



useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > lastScrollY) {
      setMostrarBoton(false); // scroll hacia abajo → ocultar
    } else {
      setMostrarBoton(true);  // scroll hacia arriba → mostrar
    }
    setLastScrollY(window.scrollY);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [lastScrollY]);




const infoIconRef = useRef(null);
const [mostrarModalAtencion, setMostrarModalAtencion] = useState(false);
const [modalPos, setModalPos] = useState({ x: 0, y: 0 });
const [iconPop, setIconPop] = useState(false);

  const [mostrarModal, setMostrarModal] = useState(false);
  const [preparacionRoll, setPreparacionRoll] = useState(""); // estado por defecto
const [categoriasAbiertas, setCategoriasAbiertas] = useState(() => {
  const inicial = {};
  ArmRoll.forEach(cat => {
    inicial[cat.nombre.toLowerCase()] = true; // todas abiertas
  });
  return inicial;
});

useEffect(() => {
  const timer = setTimeout(() => {
    abrirModalDesdeIcono();
  }, 3000);

  return () => clearTimeout(timer);
}, []);



useEffect(() => {
  const timer = setTimeout(() => {
    setMostrarModalAtencion(true);
  }, 3000);

  return () => clearTimeout(timer);
}, []);




  // 📦 Helper localStorage
  const guardarRolles = (roll) => {
    const lista = JSON.parse(localStorage.getItem("rollsPersonalizados") || "[]");
    lista.push(roll);
    localStorage.setItem("rollsPersonalizados", JSON.stringify(lista));
  };

  const cargarRolles = () => JSON.parse(localStorage.getItem("rollsPersonalizados") || "[]");

  // 🧭 Mostrar banner solo al hacer scroll
  useEffect(() => {
    const handleScroll = () => setMostrarBanner(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ⚙️ Manejo de base
  const handleBaseChange = (opcion) => {
    setRollActual((prev) => ({ ...prev, base: opcion }));
  };

  const abrirModalDesdeIcono = () => {
  if (infoIconRef.current) {
    const rect = infoIconRef.current.getBoundingClientRect();
    setModalPos({ x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 });
    
    // efecto pop
    setIconPop(true);
    setTimeout(() => setIconPop(false), 300);

    setMostrarModalAtencion(true);
  }
};




  // ⚙️ Manejo de contador para proteinas, rellenos y toppings
  const handleCounterChange = (categoria, opcion, delta) => {
    setRollActual((prev) => {
      const listaActual = prev[categoria] || [];
      const index = listaActual.findIndex((item) => item.nombre === opcion.nombre);
      let nuevaLista;

      if (index === -1 && delta > 0) {
        nuevaLista = [...listaActual, { ...opcion, cantidad: 1 }];
      } else if (index !== -1) {
        const nuevaCantidad = listaActual[index].cantidad + delta;
        if (nuevaCantidad <= 0) {
          nuevaLista = listaActual.filter((_, i) => i !== index);
        } else {
          nuevaLista = [...listaActual];
          nuevaLista[index] = { ...listaActual[index], cantidad: nuevaCantidad };
        }
      } else {
        nuevaLista = listaActual;
      }

      return { ...prev, [categoria]: nuevaLista };
    });
  };

 // 🧮 Totales calculados dinámicamente (con extra Tempura)
const totales = (() => {
  const totalBase = rollActual.base ? parseFloat(rollActual.base.precio) : 0;
  const totalProteinas = rollActual.proteinas.reduce(
    (acc, el) => acc + el.cantidad * parseFloat(el.precio),
    0
  );
  const totalRellenos = rollActual.rellenos.reduce(
    (acc, el) => acc + el.cantidad * parseFloat(el.precio),
    0
  );
  const totalToppings = rollActual.toppings.reduce(
    (acc, el) => acc + el.cantidad * parseFloat(el.precio),
    0
  );

  // ➕ Extra por Tempura
  const extraTempura = preparacionRoll === "tempura" ? 1.00 : 0;

  return {
    base: totalBase,
    proteinas: totalProteinas,
    rellenos: totalRellenos,
    toppings: totalToppings,
    extraTempura,
    general: totalBase + totalProteinas + totalRellenos + totalToppings + extraTempura,
  };
})();



// ⚙️ Guardar roll
const handleGuardarRoll = () => {
  // 🧩 Validaciones generales
  const totalProteinas =
    rollActual.proteinas?.reduce(
      (acc, p) => acc + (p.cantidad || 0),
      0
    ) || 0;

  const totalRellenos = rollActual.rellenos?.reduce(
    (acc, r) => acc + (r.cantidad || 1),
    0
  );

  const baseSeleccionada = !!rollActual.base;

  // 🔍 Detectar si la base es “Nori sin arroz”
  const baseNombre = rollActual.base?.nombre?.toLowerCase?.() || "";
  const esNoriSinArroz = baseNombre.includes("nori sin arroz");

  // 🧩 Validaciones
  if (!baseSeleccionada) {
    showError("Seleccioná una base antes de continuar");
    return;
  }

  // 🔹 Caso especial: Nori sin arroz
  if (esNoriSinArroz) {
    if (totalProteinas < 3 || totalRellenos < 2) {
      showError("Con Nori sin arroz debés elegir al menos 3 proteínas y 2 rellenos.");
      return;
    }
  } else {
    // 🔹 Validaciones normales
    const cumplePrimeraCondicion = totalProteinas >= 2 && baseSeleccionada;
    const cumpleSegundaCondicion = totalRellenos >= 2 && totalProteinas >= 1;

    if (!cumplePrimeraCondicion && !cumpleSegundaCondicion) {
      showError(
        "Debés elegir al menos 2 proteínas y 1 base, o 2 rellenos y 1 proteína."
      );
      return;
    }
  }

  // ✅ Validación de preparación
  if (!preparacionRoll) {
    showError(
      "Seleccioná la preparación del roll (Frío o Tempura) antes de continuar"
    );
    return;
  }

  // ✅ Construcción del roll final
  const rollFinal = {
    ...rollActual,
    total: totales.general,
    preparacion: preparacionRoll,
    nombrePersonalizado:
      deseaNombrar === "si"
        ? nombreRoll.trim() || "Roll Personalizado"
        : null,
  };

  guardarRolles(rollFinal);
  showSuccess("¡Roll personalizado armado con éxito!");

  // 🔄 Reset para nuevo roll
  setRollActual(nuevoRoll());
  setNombreRoll("");
  setDeseaNombrar("no");
  setMostrarModalAgregarMas(true);
};



const inicio = () => {
  setMostrarModalAgregarMas(false)
    setMostrarModal(true);
    setTimeout(() => {
      setMostrarModal(false);
      navigate("/");
    }, 1000);
  };
  const continuar  = () => {
  setMostrarModalAgregarMas(false)
    setMostrarModal(true);
    setTimeout(() => {
      setMostrarModal(false);
      navigate("/form");
    }, 1000);
  };
  const armaTuRoll  = () => {
  setMostrarModalAgregarMas(false)
    setMostrarModal(true);
    setTimeout(() => {
      setMostrarModal(false);
      navigate("/rollperson");
    }, 1000);
  };

  const toggleCategoria = (nombre) => {
  setCategoriasAbiertas(prev => ({
    ...prev,
    [nombre]: !prev[nombre],
  }));
};




 return (
  <div className=" min-h-screen items-center">
     {/* 🔸 Banner flotante superior */}
    <AnimatePresence>
      {mostrarBanner && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed top-4 sm:top-5 inset-x-0 mx-auto w-[90%] sm:w-[95%] max-w-md bg-white/70 backdrop-blur-lg shadow-2xl rounded-2xl px-6 py-4 z-50 border border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-2"
        >
          <span className="font-bold text-gray-800 text-lg text-center sm:text-left">Total actual:</span>
          <span className="text-red-600 font-extrabold text-lg text-center sm:text-right">
            {totales.general.toFixed(2)} USD
          </span>
        </motion.div>
      )}
    </AnimatePresence>
   <div className="pt-[100px] p-4 space-y-6 pb-20">
<motion.div
  initial={{ opacity: 0, y: 30 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.4 }}
  className="bg-white rounded-2xl shadow-md p-8 relative overflow-hidden flex flex-col items-center text-center"
>
  {/* Icono de info en esquina */}
  <div
    ref={infoIconRef}
    className={`absolute top-4 right-4 cursor-pointer z-20 transition-transform duration-300 ${iconPop ? "scale-125" : "scale-100"}`}
    onClick={abrirModalDesdeIcono}
  >
    <Info size={28} className="text-red-600" />
  </div>

  {/* Título principal */}
       <div className="flex justify-center -mt-16 mb-2">
  <img
    src={Japan}
    alt="Logotipo Japan Food"
    className="w-90 h-90 object-contain"
  />
</div>

  {/* Selección de preparación */}
  <p className="text-gray-500 text-lg -mt-16 font-medium mb-3">
    Elige la preparación de tu roll:
  </p>
  <div className="flex gap-10 justify-center mb-5">
    <label className="flex items-center gap-2 text-gray-500 font-semibold text-lg cursor-pointer">
      <input
        type="radio"
        name="preparacionRoll"
        value="tempura"
        checked={preparacionRoll === "tempura"}
        onChange={() => setPreparacionRoll("tempura")}
        className="accent-red-500 w-5 h-5"
      />
      Tempura
    </label>
    <label className="flex items-center gap-2 text-gray-500 font-semibold text-lg cursor-pointer">
      <input
        type="radio"
        name="preparacionRoll"
        value="frio"
        checked={preparacionRoll === "frio"}
        onChange={() => setPreparacionRoll("frio")}
        className="accent-red-500 w-5 h-5"
      />
      Frío
    </label>
  </div>

  {/* Pregunta de nombre */}
  <p className="text-gray-500 text-lg font-medium mb-5">
    ¿Deseas colocar un nombre a tu roll personalizado?
  </p>
  <div className="flex gap-10 justify-center mb-5">
    <label className="flex items-center gap-2 text-gray-500 font-semibold text-lg cursor-pointer">
      <input
        type="radio"
        name="nombraRoll"
        value="si"
        checked={deseaNombrar === "si"}
        onChange={() => setDeseaNombrar("si")}
        className="accent-red-500 w-5 h-5"
      />
      Sí
    </label>
    <label className="flex items-center gap-2 text-gray-500 font-semibold text-lg cursor-pointer">
      <input
        type="radio"
        name="nombraRoll"
        value="no"
        checked={deseaNombrar === "no"}
        onChange={() => setDeseaNombrar("no")}
        className="accent-red-500 w-5 h-5"
      />
      No
    </label>
  </div>

  {deseaNombrar === "si" && (
    <input
      type="text"
      placeholder="Escribe su nombre"
      value={nombreRoll}
      onChange={e => setNombreRoll(e.target.value)}
      className="mb-4 w-full p-3 border border-gray-200 rounded shadow-md bg-transparent placeholder-gray-400 focus:outline-none"
    />
  )}

  {/* 🔹 Modal de Atención emergiendo desde icono */}
  <AnimatePresence>
    {mostrarModalAtencion && (
      <motion.div
        key="modal-atencion"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-white/30 backdrop-blur-md flex items-center justify-center z-50"
      >
        <motion.div
          initial={{
            x: modalPos.x - window.innerWidth / 2,
            y: modalPos.y - window.innerHeight / 2,
            scale: 0
          }}
          animate={{ x: 0, y: 0, scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="bg-white rounded-2xl p-6 shadow-2xl max-w-md w-[90%] text-center"
        >
          <h3 className="text-2xl font-bold text-red-600 mb-4 flex items-center justify-center gap-2">
            <Info size={24} /> Atención
          </h3>
          <p className="text-gray-700 text-lg mb-2">
            Debes elegir al menos <strong className="text-red-600">2 proteínas</strong>, <strong className="text-red-600">1 relleno</strong> y <strong className="text-red-600">1 base</strong> o <strong className="text-red-600">2 rellenos</strong>, <strong className="text-red-600">1 proteina</strong> y <strong className="text-red-600">1 base.</strong>
          </p>
          <p className="text-gray-700 text-lg mb-2">
            Tu roll personalizado trae <strong className="text-red-600">10 piezas</strong>.
          </p>
          <p className="text-gray-700 text-lg">
            Al seleccionar Tempura, tendrá un costo adicional de <strong className="text-red-600">1.00 USD</strong>.
          </p>
          <button
            onClick={() => setMostrarModalAtencion(false)}
            className="mt-6 bg-red-600 text-white px-6 py-2 rounded-xl font-semibold hover:bg-red-700 transition"
          >
            Entendido
          </button>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
</motion.div>
{/* 🔹 Secciones del ArmRoll */}
   {ArmRoll.map((categoria, i) => {
  const nombre = categoria.nombre.toLowerCase();
  const isBase = nombre === "base";
  const keyTotales = isBase ? "base" : nombre;
  const abierta = categoriasAbiertas[nombre]; // ya tiene siempre true al inicio

  return (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: i * 0.1 }}
      className="bg-white rounded-2xl shadow-md p-5 relative overflow-hidden"
      layout
    >
      {/* 🔹 Header: Título + botón */}
      <div
        className="flex justify-between items-center mb-4 cursor-pointer"
        onClick={() => toggleCategoria(nombre)}
      >
        <h2 className="text-2xl font-bold text-red-600 underline decoration-red-500 underline-offset-4 rounded-md">
          {categoria.nombre}
        </h2>
          {abierta ? <FaChevronUp size={20} className="text-red-600" /> : <FaChevronDown size={20} className="text-red-600" />}
      </div>

      {/* 🔹 Contenido colapsable */}
      <AnimatePresence initial={false}>
        {abierta && (
          <motion.div
            key="contenido"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="grid gap-3 auto-rows-min overflow-hidden"
          >
            {categoria.option.map((opcion, idx) => {
              const isCamaronesSpecial =
                nombre === "proteinas" && opcion.nombre.toLowerCase() === "camarones";

              const camaronesItem =
                nombre === "proteinas"
                  ? rollActual.proteinas?.find(
                      item => item.nombre.toLowerCase() === "camarones"
                    )
                  : null;

              return (
                <div
                  key={idx}
                  className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-gray-50 hover:bg-gray-100 transition rounded-xl p-3 gap-2"
                >
                  <span className="text-gray-500 text-md font-bold w-full mb-2 sm:mb-0 ">
                    {opcion.nombre}
                  </span>

                  {isBase ? (
  <div className="flex items-center justify-between w-full">
    <div className="flex items-center gap-3">
      <input
        type="radio"
        name="base"
        checked={rollActual.base?.nombre === opcion.nombre}
        onChange={() => {
          handleBaseChange(opcion);
          showSuccess(`Base ${opcion.nombre} seleccionada correctamente!`);
        }}
        className="w-5 h-5 accent-red-500"
        aria-label={`Seleccionar base ${opcion.nombre}`}
      />
      
    </div>
    <span className="text-md text-gray-600 font-semibold">
      {opcion.precio} USD
    </span>
  </div>
) : (
                    <div className="flex flex-col w-full sm:w-auto items-start gap-2">
                      {/* Contador */}
                      <div className="flex justify-between w-full sm:w-auto items-center flex-shrink-0 min-w-[180px]">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleCounterChange(nombre, opcion, -1)}
                            className="bg-neutral-200 rounded-full p-2 hover:bg-neutral-300 transition"
                            disabled={
                              !(
                                rollActual[nombre]?.find(
                                  item => item.nombre === opcion.nombre
                                )?.cantidad > 0
                              )
                            }
                          >
                            <Minus size={18} />
                          </button>
                          <span className="w-5 text-center">
                            {
                              rollActual[nombre]?.find(
                                item => item.nombre === opcion.nombre
                              )?.cantidad || 0
                            }
                          </span>
                          <button
                            onClick={() => {
                              handleCounterChange(nombre, opcion, 1);
                              showSuccess(`${opcion.nombre} agregado!`);
                            }}
                            className="bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition"
                          >
                            <Plus size={18} />
                          </button>
                        </div>
                        <span className="text-md text-gray-600 font-semibold ml-2 sm:ml-4">
                          {opcion.precio} USD
                        </span>
                      </div>

                      {/* Tempura / Al vapor */}
                      {isCamaronesSpecial && camaronesItem && camaronesItem.cantidad > 0 && (
                        <div className="flex flex-col sm:flex-row gap-4 mt-2 ml-1">
                          <label className="flex items-center gap-1 text-sm">
                            <input
                              type="radio"
                              name={`camarones-preparacion-${idx}`}
                              value="tempura"
                              checked={camaronesItem.preparacion === "tempura"}
                              onChange={() =>
                                setRollActual(prev => {
                                  const lista = [...prev.proteinas];
                                  const index = lista.findIndex(
                                    item => item.nombre.toLowerCase() === "camarones"
                                  );
                                  lista[index] = { ...lista[index], preparacion: "tempura" };
                                  return { ...prev, proteinas: lista };
                                })
                              }
                              className="w-4 h-4 accent-red-500"
                            />
                            Tempura
                          </label>
                          <label className="flex items-center gap-1 text-sm">
                            <input
                              type="radio"
                              name={`camarones-preparacion-${idx}`}
                              value="vapor"
                              checked={camaronesItem.preparacion === "vapor"}
                              onChange={() =>
                                setRollActual(prev => {
                                  const lista = [...prev.proteinas];
                                  const index = lista.findIndex(
                                    item => item.nombre.toLowerCase() === "camarones"
                                  );
                                  lista[index] = { ...lista[index], preparacion: "vapor" };
                                  return { ...prev, proteinas: lista };
                                })
                              }
                              className="w-4 h-4 accent-red-500"
                            />
                            Al vapor
                          </label>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Subtotal */}
      <div className="mt-4 text-lg font-bold text-gray-700 text-right">
        Subtotal: {(totales[keyTotales] || 0).toFixed(2)} USD
      </div>
    </motion.div>
  );
})}
   </div>
  

{/* 🔹 Botón Confirmar flotante inferior con efecto scroll */}
{!mostrarModalAtencion && (
  <AnimatePresence>
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed bottom-4 inset-x-0 mx-auto z-50 flex justify-center"
      style={{ pointerEvents: 'auto' }}
    >
      <button
        onClick={() => handleGuardarRoll(preparacionRoll)}
        className="bg-gradient-to-r from-red-500 to-red-700 text-white px-10 py-3 rounded-xl shadow-lg font-bold text-lg hover:scale-105 active:scale-95 transition-transform duration-200"
      >
        Confirmar
      </button>
    </motion.div>
  </AnimatePresence>
)}





<AnimatePresence>
  {mostrarModalAgregarMas && (
    <motion.div
      key="modal-agregar"
      initial={{ x: "100vw", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: "100vw", opacity: 0 }}
      transition={{ type: "tween", duration: 0.7 }}
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70] flex items-center justify-center"
    >
      {/* Contenedor del modal centrado */}
      <div className="bg-neutral-900 rounded-xl p-6 shadow-xl w-[90%] max-w-xs text-white">
        <h3 className="text-center text-lg font-bold mb-6">
          ¿Deseas agregar algún extra? 
        </h3>
        <div className="flex flex-col gap-3">
          <button
            onClick={inicio}
            className="w-full bg-neutral-700 hover:bg-neutral-600 transition text-white font-semibold py-2 rounded"
          >
            Sí, agregar extras
          </button>

          <button
            onClick={() => {
              sessionStorage.setItem("modalVisto", "true");
              armaTuRoll();
            }}
            className="w-full bg-neutral-700 hover:bg-neutral-600 transition text-white font-semibold py-2 rounded"
          >
            Sí, crear otro roll personalizado
          </button>

          <button
            onClick={() => {
              sessionStorage.setItem("modalVisto", "true");
              continuar();
            }}
            className="w-full bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 transition text-white font-semibold py-2 rounded"
          >
            No, continuar
          </button>
        </div>
      </div>
    </motion.div>
  )}
</AnimatePresence>


<PageModal
        mostrarModal={mostrarModal}
        onComplete={() => setMostrarModal(false)}
      />

  </div>
);


};

export default RollPerson;
